import {
  getConcreteStartSet,
  type APISlideAttributes,
  type ArdoqId,
} from '@ardoq/api-types';
import { isTruthy } from '@ardoq/common-helpers';
import { uniq, uniqBy } from 'lodash';

export const getStartComponentIds = (slides: APISlideAttributes[]): ArdoqId[] =>
  uniq(
    slides.flatMap(({ loadedStates }) =>
      (loadedStates ?? []).flatMap(getConcreteStartSet)
    )
  );

export const isContextualSlide = (slide: APISlideAttributes): boolean =>
  getStartComponentIds([slide]).length > 0;

export const getStartComponentTypes = <Type extends { typeId: ArdoqId }>(
  slides: APISlideAttributes[],
  typeById: Record<ArdoqId, Type>
): Type[] =>
  uniqBy(
    getStartComponentIds(slides)
      .map(id => typeById[id])
      .filter(isTruthy),
    'typeId'
  );
